module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-02.8716dc4d.jpg";